<svg
	width="18"
	height="18"
	viewBox="0 0 20 20"
	xmlns="http://www.w3.org/2000/svg"
	class="chat_icon"
	fill="currentColor"
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M0.984558 9.99902C0.984558 4.97598 5.09432 0.866211 10.1174 0.866211C15.1404 0.866211 19.2502 4.97598 19.2502 9.99902C19.2502 15.0221 15.1404 19.1318 10.1174 19.1318C5.09432 19.1318 0.984558 15.0221 0.984558 9.99902ZM8.97577 7.71582C8.97577 7.03086 8.51913 6.57422 7.83417 6.57422C7.14921 6.57422 6.69257 7.03086 6.69257 7.71582C6.69257 8.40078 7.14921 8.85742 7.83417 8.85742C8.51913 8.85742 8.97577 8.40078 8.97577 7.71582ZM10.1174 14.5654C8.17665 14.5654 6.69257 13.0813 6.69257 11.1406H13.5422C13.5422 13.0813 12.0581 14.5654 10.1174 14.5654ZM11.259 7.71582C11.259 8.40078 11.7156 8.85742 12.4006 8.85742C13.0855 8.85742 13.5422 8.40078 13.5422 7.71582C13.5422 7.03086 13.0855 6.57422 12.4006 6.57422C11.7156 6.57422 11.259 7.03086 11.259 7.71582Z"
	/>
</svg>
